export const getFilters = '/api/v1/catalog/filters';
export const findCoursesByCriteria = page => `/api/v1/catalog?page=${page}`;
